import React, { FC } from 'react';
import hideShowIcon from '../../../assets/icons/hide_show.svg';
import './move-handle-icon.scss';

const MoveHandleIcon: FC = (): JSX.Element => {
  return (
    <img
      className='move-handle-icon'
      src={hideShowIcon} alt='Draggable Icon'
    />
  );
};

export default MoveHandleIcon;
